import { render, staticRenderFns } from "./WxOutboundGoods.vue?vue&type=template&id=0c3f72f2&scoped=true&"
import script from "./WxOutboundGoods.vue?vue&type=script&lang=js&"
export * from "./WxOutboundGoods.vue?vue&type=script&lang=js&"
import style0 from "./WxOutboundGoods.vue?vue&type=style&index=0&id=0c3f72f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f72f2",
  null
  
)

export default component.exports